import { render, staticRenderFns } from "./UploadTaxSituationProofModal.vue?vue&type=template&id=7ccfdffe&"
import script from "./UploadTaxSituationProofModal.vue?vue&type=script&lang=js&"
export * from "./UploadTaxSituationProofModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports